export const MAX_CAMPAIGN_INFLUENCER_TAG_NAME_LENGTH = 64;

// Mirrors the backend's reserved names for campaign defaults; the API enforces this policy.
export const DEFAULT_CAMPAIGN_INFLUENCER_TAG_NAMES = [
  'Shortlisted',
  'Underrated Score',
  'Finalist',
  'Maybe',
  'Overrated Score',
] as const;

export function isDefaultCampaignInfluencerTagName(name: string): boolean {
  const normalizedName = name.trim().toLowerCase();
  return DEFAULT_CAMPAIGN_INFLUENCER_TAG_NAMES.some((defaultName) => defaultName.toLowerCase() === normalizedName);
}

export interface CampaignInfluencerTag {
  tagId: string;
  name: string;
  campaignId?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface CreateCampaignInfluencerTagRequest {
  name: string;
  campaignId?: string;
}

export interface RenameCampaignInfluencerTagRequest {
  name: string;
}

export function getCampaignInfluencerTagLabel(tag: CampaignInfluencerTag): string {
  return tag.campaignId ? tag.name : `${tag.name} (G)`;
}
